import { FC, useMemo } from 'react'
import styles from 'components/features/socialFeed/ComposeLayout/ComposeLayout.styl'
import { WithComposeId } from 'interfaces/feed'
import cn from 'classnames'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { createComposeExpandedPartSelector } from 'selectors/feedComposeSelectors'
import { useComposeState } from 'helpers/hookHelpers'

type ComposeLayoutProps =
  & WithComposeId

export const ComposeLayout: FC<ComposeLayoutProps> = (props) => {
  const {
    composeId,
    children,
  } = props

  const { isEdit } = useComposeState(composeId, { isEdit: null })
  const composeExpandedPartSelector = useMemo(createComposeExpandedPartSelector, [])
  const isExpanded = useStoreSelector((state) => composeExpandedPartSelector(state, props))

  const rootClassName = useMemo(() => cn(styles.composeLayout, {
    [styles.editMode]: !!isEdit,
    [styles.isFocused]: !!isExpanded,
  }), [isEdit, isExpanded])

  return (
    <div className={ rootClassName }>
      { children }
    </div>
  )
}
